<template>
  <hic-dialog title="打印模版编辑" :visible="visible" @open="openEditor" @close="cancel" :close-on-click-modal="false" width="50%">
    <el-form :model="value" :rules="comRules" ref="editor" :label-width="formLabelWidth" style="padding-right: 5rem">
      <el-form-item label="名称" prop="name">
        <el-input class="default-input" @change="genCode" size="small" type="text" placeholder="请输入" v-model="value.name"> </el-input>
      </el-form-item>
      <el-form-item label="编码" prop="code">
        <el-input class="default-input" size="small" type="text" placeholder="请输入" v-model="value.code" :disabled="!!value.id"> </el-input>
      </el-form-item>
      <el-form-item label="应用" prop="sys">
        <hic-dict-selector dict-type="MySys" v-model="value.sys" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input class="default-input" size="small" type="textarea" :rows="2" placeholder="请输入" v-model="value.memo"> </el-input>
      </el-form-item>

      <el-form-item v-if="value.id" label="模板附件">
        <hic-attachment-uploader :main-id="value.id" :sys="value.sys" business="打印模板" :before-fun="beforeUpload" @ok="uploaded" />
        <el-link v-if="tmpl.id" type="primary" @click="download" icon="el-icon-download">【{{ tmpl.id }}】 {{ tmpl.originalName }}</el-link>
      </el-form-item>

      <!-- <el-form-item label="数据结构">
        <el-input class="default-input" size="small" type="textarea" :rows="4" placeholder="请输入" v-model="value.struct"> </el-input>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button v-if="value.id" type="primary" @click="saveAndNext" :disabled="disabledSaveAndNext">保存并继续新建</el-button>
      <el-button v-if="value.id" type="primary" @click="save(true)" :disabled="isSaving">确 定</el-button>
      <el-button v-if="!value.id" type="primary" @click="save(false)" :disabled="isSaving">保 存</el-button>
    </div>
  </hic-dialog>
</template>
<script>
  import api from "./api";
  import { pinyin as py } from "../../../packages/masterdata";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      value: {},
      visible: { type: Boolean, default: false },
    },
    data() {
      return {
        comRules: {
          name: [
            {
              required: true,
              message: "请输入名称",
              trigger: "blur",
            },
            {
              max: 20,
              message: "名称长度在 20 个字符以内",
              trigger: "blur",
            },
          ],
          code: [
            {
              required: true,
              message: "请输入模版编码",
              trigger: "blur",
            },
            {
              max: 20,
              message: "编码长度在 20 个字符以内",
              trigger: "blur",
            },
          ],
          sys: [
            {
              required: true,
              message: "请输入选择子系统",
              trigger: "blur",
            },
          ],
        },
        editorShow: false,
        loading: false,
        formLabelWidth: "120px",

        autoNext: false,
        disabledSaveAndNext: false,
        isSaving: false,
        tmpl: {},
      };
    },
    computed: {
      ...mapGetters(["dict"]),
      dictTypeDict() {
        return this.dict.DictType.find((d) => this.value.type == d.code) || {};
      },
      isChain() {
        return this.dictTypeDict.parentType && this.dictTypeDict.parentType != this.dictTypeDict.code;
      },
      isSelfChain() {
        return this.dictTypeDict.parentType == this.dictTypeDict.code;
      },
    },
    watch: {
      value() {
        this.init();
      },
    },
    methods: {
      init() {
        this.tmpl = {};
        if (this.value.struct && !isNaN(this.value.struct)) {
          api.Attachment.get(this.value.struct).then((res) => {
            this.tmpl = res;
          });
        }
      },
      genCode(chns) {
        if (!this.value.id) {
          this.$set(this.value, "code", py.chnToPinYin(chns));
        }
      },
      openEditor() {
        this.disabledSaveAndNext = false;
        this.isSaving = false;
      },
      save(isClose) {
        this.$refs.editor.validate().then((valid) => {
          if (valid) {
            api.PrintTemplate.save(this.value)
              .then((res) => {
                if (isClose) {
                  this.$message.success("保存成功");
                  this.$emit("update:visible", false);
                  this.$emit("saved");
                } else {
                  if (this.autoNext) {
                    this.autoNext = false
                    this.$set(this.value, "id", null)
                    this.$set(this.value, "code", null)
                    this.$set(this.value, "name", null)
                    this.tmpl = {}
                    this.$emit("saved");
                  } else {
                    this.$set(this.value, "id", res.id)
                  }
                }
              })
              .catch((err) => {
                this.$message.error(err);
              });
          }
        });
      },
      saveAndNext() {
        this.autoNext = true;
        this.save();
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      beforeUpload(file) {
        console.log(file);
        if (!this.value.id) {
          this.$message.warning("先保存，然后才能上传附件！");
          return false;
        }
        if (!file.name.endsWith(".grf")) {
          this.$message.warning("此处只允许上传后缀为 grf 的模板文件！");
          return false;
        }
        return true;
      },
      uploaded(attachment) {
        api.PrintTemplate.patch({ id: this.value.id, struct: attachment.id }).then((res) => {
          this.value.struct = attachment.id;
          this.value.lockKey = res.lockKey;

          if (this.tmpl?.id) {
            api.Attachment.del(this.tmpl.id);
          }
          this.tmpl = attachment;
        });
      },
      download() {
        if (this.tmpl?.id) {
          api.Attachment.download(this.tmpl.id, this.tmpl.originalName);
        }
      },
    },
  };
</script>
<style scoped></style>
